import React, { useEffect, useState, useContext } from 'react'
import {
    CognitoIdentityProviderClient,
    ForgotPasswordCommand
} from "@aws-sdk/client-cognito-identity-provider"
import CloudformationOutputs from '../CloudformationOutputs.json'
import { GlobalContext } from '../GlobalContext'
import { subscribe } from "../utils/pubsub"
import Spinner from "../ui-elements/Spinner"
import Button from '../formfields/Button'
import RedAlert from '../ui-elements/RedAlert'
import Modal from '../ui-elements/Modal'
import { useNavigate, useParams } from 'react-router-dom'
import Password from './auth_formfields/Password'
import Text from './auth_formfields/Text'

type Props = {
    setForgotPasswordEmail: React.Dispatch<React.SetStateAction<any>>
    forgotPasswordEmail: string
}


function ForgotPasswordForm({
    setForgotPasswordEmail,
    forgotPasswordEmail
}: Props) {

    const {
        tableData,
        setShowModal,
        sendMessageToWebsocket,
        currentOrganisation,
        orgIdFromQrCode,
        t
    } = useContext(GlobalContext)

    const navigate = useNavigate()
    const [formFields, setFormFields] = useState<ObjectStringKeyAnyValue>({})
    const [formErrors, setFormErrors] = useState<ObjectStringKeyAnyValue>({})


    const validate = () => {
        let isValid = true
        let errorMessage = ''
        let emailRegex = new RegExp("^.+@.+")
        let newFormErrors: ObjectStringKeyAnyValue = {}

        if (
            !formFields["emailAddress"] ||
            !emailRegex.test(formFields["emailAddress"])
        ) {
            isValid = false
            newFormErrors["emailAddress"] = t('Auth.ForgotPasswordForm.pleaseEnterEmail')
        }
        setFormErrors(newFormErrors)
        return isValid
    }




    const validateAndSave = () => {
        const isValid = validate()

        if (isValid) {
            setShowModal({ "spinner": t('Auth.ForgotPasswordForm.sendingCode') })
            const client = new CognitoIdentityProviderClient({ region: CloudformationOutputs['AWSRegion'] });
            const username = formFields["emailAddress"].toLowerCase()
            const command = new ForgotPasswordCommand({
                ClientId: CloudformationOutputs['UserPoolClientId'],
                Username: username,
            })
            client.send(command)
                .then((response: any) => {
                    //console.log("Reset code sent:", response)
                    setShowModal(null)
                    setForgotPasswordEmail(username)
                })
                .catch((error: any) => {
                    console.error("Error retrieving password", error)
                    setShowModal({ "error": t('Auth.ForgotPasswordForm.errorRetrievingPassword') })
                })
        }
    }




    return <div className={`w-full flex flex-col gap-4`}>

        <h3 className={`font-righteous text-2xl text-brand-dark`}>
            {t('Auth.ForgotPasswordForm.heading')}
        </h3>


        <div className={`flex flex-col gap-2`}>
            <p>{t('Auth.ForgotPasswordForm.emailAddress')}:</p>
            <Text
                labelText={''}
                formFields={formFields}
                formErrors={formErrors}
                setFormFields={setFormFields}
                fieldName={'emailAddress'}
                placeholder={''}
                size={'big'}
                center={true}
            />
        </div>

        <div className={`w-full flex flex-row gap-4`}>
            <Button
                onClick={() => navigate('/login')}
                text={t('Buttons.cancel')}
                variant={'gray'}
                size={'big'}
                sameWindow={true}
            />
            <Button
                onClick={validateAndSave}
                text={t('Buttons.next')}
                variant={'secondary'}
                size={'big'}
                sameWindow={true}
            />
        </div>
    </div>
}
export default ForgotPasswordForm